import React, { useCallback, useEffect, useRef } from 'react';
import overflowImage from '@images/wysiwyg_editor/overflow-indicator';

type TProps = {
  show: boolean;
  position?: {
    top?: number;
    left?: number;
    right?: number;
  };
};

function TextOverflowIndicator({
  show,
  position: { top = 0, right = -23, left } = {}
}: TProps) {
  const overflowIconRef = useRef(null);

  useEffect(() => {
    if (!show || !overflowIconRef.current) return;

    const icon = overflowIconRef.current;

    $(icon).popover();

    return () => $(icon).popover('destroy');
  }, [show]);

  const handleClick = useCallback((e) => {
    e.stopPropagation();
  }, []);

  if (!show) return null;

  return (
    <img
      ref={overflowIconRef}
      onClick={handleClick}
      src={overflowImage}
      alt="Text flows outside of content area"
      tabIndex="0"
      role="button"
      data-toggle="popover"
      data-trigger="focus"
      data-content="There is an overflow of text. Please adjust the text or text box."
      data-placement="bottom"
      data-container="body"
      style={{
        position: 'absolute',
        left: left,
        right: right,
        top: top,
        cursor: 'default'
      }}
    />
  );
}

export default TextOverflowIndicator;
